// extracted by mini-css-extract-plugin
export default {"poppins":"'Poppins', sans-serif","lightBlue":"#5956D6","form_heading":"style_form_heading__4Qkht","form_subheading":"style_form_subheading__8aYCv"};